import { useTranslation } from 'react-i18next';
import { products } from '../data/products';
import ProductCard from '../components/ProductCard';
import CategoryFilter from '../components/CategoryFilter';
import { useState } from 'react';

const ProductsPage = () => {
  const { t, i18n } = useTranslation();
  const [categoriesSelected, setCategoriesSelected] = useState<string[]>(['electric-skateboard', 'accessories']);

  // Only blueboard products, filtered by selected categories
  const blueboardProducts = products.filter(p => p.brand === 'blueboard' && p.category && categoriesSelected.includes(p.category));
  const categories = ['electric-skateboard', 'accessories'];

  return (
    <div className="bg-white min-h-screen py-12" dir={i18n.language === 'he' ? 'rtl' : 'ltr'}>
      <div className="container mx-auto px-4">
        <h1 className="text-3xl font-bold text-center mb-12">{t('products.title', 'Products')}</h1>
        <CategoryFilter categories={categories} selected={categoriesSelected} onChange={setCategoriesSelected} />
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-12">
          {blueboardProducts.map((product) => (
            <ProductCard key={product.id} product={product} showPrice={typeof product.price === 'number'} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProductsPage; 